import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import {
  goBackHomeMsg,
  greetingNoNameMsg,
  invitationLandingExpiredInstructionsMsg,
  invitationLandingExpiredIntroMsg,
  invitationLandingExpiredTitleMsg,
  t,
} from '../../common/i18n/index.js';
import type { JSX } from 'react';

import './InvitationLandingPage.scss';

export const InvitationLandingExpiredPage = (): JSX.Element => {
  return (
    <div className="ds-container">
      <div className={`of-invitation-landing__body ${dsClass.PADDING_7}`}>
        <CL.Grid>
          <CL.GridRow>
            <CL.GridCol colWidthXS={4} colWidthS={8} colWidthM={6} colWidthL={7}>
              <div className={`${dsClass.PADDING_0}`}>
                <h1>{t.WJUQ(invitationLandingExpiredTitleMsg)}</h1>

                <div className={`${dsClass.MARGIN_BOTTOM_4}`}>
                  <p className={`${dsClass.FONT_WEIGHT_BOLD}`}>
                    {t.UC34(greetingNoNameMsg)},<br></br>
                    {t.X935(invitationLandingExpiredIntroMsg)}
                  </p>
                </div>

                <p>{t.TK81(invitationLandingExpiredInstructionsMsg)}</p>

                <div className={`${dsClass.MARGIN_TOP_8}`}>
                  <CL.Button size="l" onClick={() => (window.location.href = '/')}>
                    {t.G24H(goBackHomeMsg)}
                  </CL.Button>
                </div>
              </div>
            </CL.GridCol>

            <CL.GridCol colWidthXS={4} colWidthS={8} colWidthM={6} colWidthL={5}>
              <div
                className={`of-invitation-landing__illustration ${dsClass.DISPLAY_FLEX} ${dsClass.JUSTIFY_CONTENT_CENTER} ${dsClass.ALIGN_ITEMS_CENTER} ${dsClass.PADDING_VERTICAL_4} ${dsClass.PADDING_HORIZONTAL_0} ${'of-invitation-landing__illustration--expired'}`}
              />
            </CL.GridCol>
          </CL.GridRow>
        </CL.Grid>
      </div>
    </div>
  );
};
